import FeedbackPanel from "@shared/components/modals/FeedbackPanel";
import ModalBlank from "@shared/components/modals/ModalBlank";
import { useProfile } from "@shared/hooks/useProfile";
import theme from "@shared/utils/themeColors";
import { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { useOrganization } from "../hooks/useOrganization";

function SettingsSidebar() {
  const location = useLocation();
  const { pathname } = location;
  const [feedbackModalOpen, setFeedbackModalOpen] = useState(false);
  const { organization } = useOrganization();
  const { user } = useProfile();

  return (
    <div className="flex flex-nowrap overflow-x-scroll no-scrollbar md:block md:overflow-auto px-3 py-6 border-b md:border-b-0 md:border-r border-gray-200 dark:border-gray-700/60 min-w-[15rem] md:space-y-3">
      {/* Group 1 */}
      <div>
        <div className="text-xs font-semibold text-gray-400 dark:text-gray-500 uppercase mb-3">
          Account settings
        </div>
        <ul className="flex flex-nowrap md:block mr-3 md:mr-0">
          <li className="mr-0.5 md:mr-0 md:mb-0.5">
            <NavLink
              end
              to="/settings/account"
              className={`flex items-center px-2.5 py-2 rounded-lg whitespace-nowrap ${
                pathname.includes("/settings/account") &&
                `bg-[linear-gradient(135deg,var(--tw-gradient-stops))] ${theme.bg.gradientPrimary}`
              }`}
            >
              <svg
                className={`shrink-0 fill-current mr-2 ${
                  pathname.includes("/settings/account")
                    ? theme.text.brand
                    : theme.text.secondary
                }`}
                width="16"
                height="16"
                viewBox="0 0 16 16"
              >
                <path d="M8 9a4 4 0 1 1 0-8 4 4 0 0 1 0 8Zm0-2a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm-5.143 7.91a1 1 0 1 1-1.714-1.033A7.996 7.996 0 0 1 8 10a7.996 7.996 0 0 1 6.857 3.877 1 1 0 1 1-1.714 1.032A5.996 5.996 0 0 0 8 12a5.996 5.996 0 0 0-5.143 2.91Z" />
              </svg>
              <span
                className={`text-sm font-medium ${
                  pathname.includes("/settings/account")
                    ? theme.text.brand
                    : theme.text.secondary
                }`}
              >
                My Account
              </span>
            </NavLink>
          </li>
          {user?.id === organization?.userId && (
            <li className="mr-0.5 md:mr-0 md:mb-0.5">
              <NavLink
                end
                to="/settings/organization"
                className={`flex items-center px-2.5 py-2 rounded-lg whitespace-nowrap ${
                  pathname.includes("/settings/organization") &&
                  `bg-[linear-gradient(135deg,var(--tw-gradient-stops))] ${theme.bg.gradientPrimary}`
                }`}
              >
                <svg
                  className={`shrink-0 fill-current mr-2 ${
                    pathname.includes("/settings/organization")
                      ? theme.text.brand
                      : theme.text.secondary
                  }`}
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                >
                  <g className="nc-icon-wrapper">
                    <path
                      d="m15,7h-6c-1.103,0-2,.897-2,2v8h10v-8c0-1.103-.897-2-2-2Zm-4,7c0,.552-.447,1-1,1s-1-.448-1-1v-.5c0-.552.447-1,1-1s1,.448,1,1v.5Zm0-3.5c0,.552-.447,1-1,1s-1-.448-1-1v-.5c0-.552.447-1,1-1s1,.448,1,1v.5Zm4,3.5c0,.552-.447,1-1,1s-1-.448-1-1v-.5c0-.552.447-1,1-1s1,.448,1,1v.5Zm0-3.5c0,.552-.447,1-1,1s-1-.448-1-1v-.5c0-.552.447-1,1-1s1,.448,1,1v.5Z"
                      strokeWidth="0"
                    ></path>
                    <path
                      d="m4,17V4.754c0-.446.296-.839.725-.962l5-1.429c.639-.183,1.275.297,1.275.962v1.674"
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                    ></path>
                    <line
                      x1="3"
                      y1="17"
                      x2="17"
                      y2="17"
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                    ></line>
                  </g>
                </svg>
                <span
                  className={`text-sm font-medium ${
                    pathname.includes("/settings/organization")
                      ? theme.text.brand
                      : theme.text.secondary
                  }`}
                >
                  Organization
                </span>
              </NavLink>
            </li>
          )}
          <li className="mr-0.5 md:mr-0 md:mb-0.5">
            <NavLink
              end
              to="/settings/notifications"
              className={`flex items-center px-2.5 py-2 rounded-lg whitespace-nowrap ${
                pathname.includes("/settings/notifications") &&
                `bg-[linear-gradient(135deg,var(--tw-gradient-stops))] ${theme.bg.gradientPrimary}`
              }`}
            >
              <svg
                className={`shrink-0 fill-current mr-2 ${
                  pathname.includes("/settings/notifications")
                    ? theme.text.brand
                    : theme.text.secondary
                }`}
                width="16"
                height="16"
                viewBox="0 0 16 16"
              >
                <path d="m9 12.614 4.806 1.374a.15.15 0 0 0 .174-.21L8.133 2.082a.15.15 0 0 0-.268 0L2.02 13.777a.149.149 0 0 0 .174.21L7 12.614V9a1 1 0 1 1 2 0v3.614Zm-1 1.794-5.257 1.503c-1.798.514-3.35-1.355-2.513-3.028L6.076 1.188c.791-1.584 3.052-1.584 3.845 0l5.848 11.695c.836 1.672-.714 3.54-2.512 3.028L8 14.408Z" />
              </svg>
              <span
                className={`text-sm font-medium ${
                  pathname.includes("/settings/notifications")
                    ? theme.text.brand
                    : theme.text.secondary
                }`}
              >
                My Notifications
              </span>
            </NavLink>
          </li>
        </ul>
      </div>
      {/* Group 2 - Admin Section */}
      {user?.role === "admin" && (
        <div>
          <div className="text-xs font-semibold text-gray-400 dark:text-gray-500 uppercase mb-3">
            Admin
          </div>
          <ul className="flex flex-nowrap md:block mr-3 md:mr-0">
            <li className="mr-0.5 md:mr-0 md:mb-0.5">
              <NavLink
                end
                to="/settings/admin-invitations"
                className={`flex items-center px-2.5 py-2 rounded-lg whitespace-nowrap ${
                  pathname.includes("/settings/admin-invitations") &&
                  `bg-[linear-gradient(135deg,var(--tw-gradient-stops))] ${theme.bg.gradientPrimary}`
                }`}
              >
                <svg
                  className={`shrink-0 fill-current mr-2 ${
                    pathname.includes("/settings/admin-invitations")
                      ? theme.text.brand
                      : theme.text.secondary
                  }`}
                  width="16"
                  height="16"
                  viewBox="0 0 20 20"
                >
                  <g fill="currentColor" className="nc-icon-wrapper">
                    <polyline
                      points="3 6 4.5 7.5 8 3.5"
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      data-color="color-2"
                    ></polyline>
                    <rect
                      x="3"
                      y="12"
                      width="4"
                      height="4"
                      rx="1"
                      ry="1"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      fill="currentColor"
                    ></rect>
                    <line
                      x1="11"
                      y1="6"
                      x2="17"
                      y2="6"
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      data-color="color-2"
                    ></line>
                    <line
                      x1="11"
                      y1="14"
                      x2="17"
                      y2="14"
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                    ></line>
                  </g>
                </svg>
                <span
                  className={`text-sm font-medium ${
                    pathname.includes("/settings/admin-invitations")
                      ? theme.text.brand
                      : theme.text.secondary
                  }`}
                >
                  Admin Invitations
                </span>
              </NavLink>
            </li>
            <li className="mr-0.5 md:mr-0 md:mb-0.5">
              <NavLink
                end
                to="/settings/member-invitations"
                className={`flex items-center px-2.5 py-2 rounded-lg whitespace-nowrap ${
                  pathname.includes("/settings/member-invitations") &&
                  `bg-[linear-gradient(135deg,var(--tw-gradient-stops))] ${theme.bg.gradientPrimary}`
                }`}
              >
                <svg
                  className={`shrink-0 fill-current mr-2 ${
                    pathname.includes("/settings/member-invitations")
                      ? theme.text.brand
                      : theme.text.secondary
                  }`}
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                >
                  <path d="M14 2H2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2Zm0 2v.4L8 8.5 2 4.4V4h12ZM2 12V6.8l5.4 3.7c.36.25.84.25 1.2 0L14 6.8V12H2Z" />
                </svg>
                <span
                  className={`text-sm font-medium ${
                    pathname.includes("/settings/member-invitations")
                      ? theme.text.brand
                      : theme.text.secondary
                  }`}
                >
                  Member Invitations
                </span>
              </NavLink>
            </li>
          </ul>
        </div>
      )}

      {/* Group 3 */}
      <div>
        <div className="text-xs font-semibold text-gray-400 dark:text-gray-500 uppercase mb-3">
          Experience
        </div>
        <ul className="flex flex-nowrap md:block mr-3 md:mr-0">
          <li className="mr-0.5 md:mr-0 md:mb-0.5">
            <button
              onClick={() => {
                setFeedbackModalOpen(true);
              }}
              className={`flex items-center px-2.5 py-2 rounded-lg whitespace-nowrap w-full text-left`}
            >
              <svg
                className={`shrink-0 fill-current mr-2 text-gray-400 dark:text-gray-500`}
                width="16"
                height="16"
                viewBox="0 0 16 16"
              >
                <path d="M14.3.3c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4l-8 8c-.2.2-.4.3-.7.3-.3 0-.5-.1-.7-.3-.4-.4-.4-1 0-1.4l8-8zM15 7c.6 0 1 .4 1 1 0 4.4-3.6 8-8 8s-8-3.6-8-8 3.6-8 8-8c.6 0 1 .4 1 1s-.4 1-1 1C4.7 2 2 4.7 2 8s2.7 6 6 6 6-2.7 6-6c0-.6.4-1 1-1z" />
              </svg>
              <span
                className={`text-sm font-medium text-gray-600 dark:text-gray-300 hover:text-gray-700 dark:hover:text-gray-200`}
              >
                Give Feedback
              </span>
            </button>

            {/* Feedback Modal */}
            <ModalBlank
              id="feedback-modal"
              modalOpen={feedbackModalOpen}
              setModalOpen={setFeedbackModalOpen}
            >
              <FeedbackPanel setModalOpen={setFeedbackModalOpen} />
            </ModalBlank>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default SettingsSidebar;
